// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ac37a5af","703":"5ee48b01","787":"3b8b3d58"}[chunkId] + ".chunk.js";
};